import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "TermListPage" */
	'pages/sales/Term/TermListPage'));

export default [{ component, exact: true, path: '/terms' }];
